import Title from "@/components/common/Typography/Title"
import { useAppSelector } from "@/lib/redux/hooks"
import { Button, Col, Row } from "antd"
import { useContext, useMemo } from "react"
import type { FC } from "react"
import { SelectPlacementContext } from "."
import { useAirports } from "@/hooks/flight/useAirports"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"

type DomesticAirportsProps = {
  /** Khi nằm trong tab (nhãn tab đã mô tả vùng), ẩn tiêu đề cột "Trong nước" */
  hideSectionTitle?: boolean
}

const DomesticAirports: FC<DomesticAirportsProps> = ({ hideSectionTitle = false }) => {
  const { t } = useTranslation()
  const domesticAirportCodes = useAppSelector(state =>
    state.flight.domesticAirports
  )
  const { getAirportCityName } = useTETranslation()

  const airports = useAirports()

  const domesticAirports = useMemo(() => {
    return ['SGN', 'DAD', 'HAN'].concat(domesticAirportCodes.filter(c => ['SGN', 'DAD', 'HAN'].indexOf(c) < 0)).map(code => airports[code])
  }, [domesticAirportCodes, airports])

  const { onChange, searching } = useContext(SelectPlacementContext)
  const searchPopular = useAppSelector(state => state.flight.searchPopular)

  if (searching && !searchPopular) {
    return <></>
  }

  return (
    <>
      {!hideSectionTitle && (
        <Row style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
          <Title level={5} style={{ margin: 0 }}>
            {t("common.domestic")}
          </Title>
        </Row>
      )}
      <Row style={hideSectionTitle ? { paddingTop: '0.4rem' } : undefined}>
        {domesticAirports.map((airport) => {
          if (!airport) return <></>
          return (
            <Col key={airport.code} span={8} style={{ paddingRight: 5, paddingBottom: 5 }}>
              <Button className="select-placement__airport-btn" onClick={() => onChange && onChange(airport)} type='text' block style={{ justifyContent: 'start' }}>
                {getAirportCityName(airport, { shownCode: false })}
              </Button>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default DomesticAirports